@if (!hideHeader()) {
	<div class="title">{{ T.EXAM_PARTICIPANT_DEVICE_STUDENT_CLINICAL_VIGNETTE_TITLE | translate }}</div>
}

<div class="clinicalVignetteBody">
	<sim-rich-text-editor-view [content]="clinicalVignetteText()" [fontSize]="'lg2'" />
</div>
